import { useNavigate } from "react-router-dom";
import logo from "../slike/pozadina9.png"

const Nav = () => {
    const navigate=useNavigate();
    const home = ()=>{
        navigate("/");
    }
    const gmailComposeUrl = `https://mail.google.com/mail/?view=cm&fs=1&to=${encodeURIComponent("info@modular-parts-system.rs")}&su=${encodeURIComponent("")}&body=${encodeURIComponent("")}`;
    const openGmail = () => {
        window.open(gmailComposeUrl, '_blank'); // Opens Gmail in a new tab
      };
    return ( 
        <div className="navbar">
            <div className="logo-slika" onClick={home}>
                 <img className="logo" src={logo} alt="logo"/>
            </div>
            <div className="meni">
                <p onClick={openGmail} style={{cursor:"pointer"}}>more info: 00381 230 590 590 | write us: info@modular-parts-system.rs</p>
                <ul style={{marginRight:"500px", marginTop:"25px"}}>
                    <li><a href="/">Home</a></li>
                    <li><div className="crta"><b>|</b></div></li>
                    <li><a href="/application">Application</a></li>
                    <li><div className="crta"><b>|</b></div></li>
                    <li><a href="/download">Download</a></li>
                    <li><div className="crta"><b>|</b></div></li>
                    <li><a href="/contact">Contact</a></li>
                </ul>
            </div>
        </div>
     );
}
 
export default Nav;